"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-ai-stars-v2.tsx
var AiStarsV2 = function AiStarsV2(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M10.7672 5.95948C11.0088 5.30651 11.9323 5.30651 12.174 5.95947L13.6387 9.91791C13.7147 10.1232 13.8765 10.2851 14.0818 10.361L18.0403 11.8258C18.6932 12.0674 18.6932 12.9909 18.0403 13.2326L14.0818 14.6973C13.8765 14.7733 13.7147 14.9351 13.6387 15.1404L12.174 19.0989C11.9323 19.7518 11.0088 19.7518 10.7672 19.0989L9.30242 15.1404C9.22646 14.9351 9.0646 14.7733 8.85931 14.6973L4.90088 13.2326C4.24791 12.9909 4.24791 12.0674 4.90088 11.8258L8.85931 10.361C9.0646 10.2851 9.22646 10.1232 9.30242 9.91791L10.7672 5.95948Z",
    fill: "currentColor"
  }), (0, _preact.h)("path", {
    d: "M17.5228 3.81104C17.6259 3.53244 18.02 3.53244 18.1231 3.81104L18.6298 5.18053C18.6622 5.26812 18.7313 5.33718 18.8189 5.36959L20.1884 5.87635C20.467 5.97944 20.467 6.37349 20.1884 6.47658L18.8189 6.98333C18.7313 7.01574 18.6622 7.0848 18.6298 7.17239L18.1231 8.54188C18.02 8.82048 17.6259 8.82048 17.5228 8.54188L17.0161 7.17239C16.9837 7.0848 16.9146 7.01574 16.827 6.98333L15.4575 6.47658C15.1789 6.37349 15.1789 5.97944 15.4575 5.87635L16.827 5.36959C16.9146 5.33718 16.9837 5.26812 17.0161 5.18053L17.5228 3.81104Z",
    fill: "currentColor"
  }));
};

var _default = AiStarsV2;
exports.default = _default;